import React from "react";
import { Box, HStack } from "../../../components/utils";
import AllocationMatrixFactorSelection from "./AllocationMatrixFactorSelection";
import AllocationMatrixRuleBuilder from "./AllocationMatrixRuleBuilder";
import AllocationMatrixReview from "./AllocationMatrixReview";

type AllocationMatrixDetailsNavigationProps = {
  currentStep: number;
  onStepChange: (e?: number) => void;
  onBackClick: () => void;
  readOnly?: boolean;
};

export default function AllocationMatrixDetailsNavigation(
  props: Readonly<AllocationMatrixDetailsNavigationProps>
) {
  const { currentStep, onStepChange, onBackClick, readOnly = false } = props;

  return (
    <Box className="w-full h-full pb-4 mx-auto align-middle">
      <HStack>
        {currentStep === 1 && (
          <AllocationMatrixFactorSelection
            onStepChange={onStepChange}
            onBackClick={onBackClick}
            readOnly={readOnly}
          />
        )}
        {currentStep === 2 && (
          <AllocationMatrixRuleBuilder
            onStepChange={onStepChange}
            onBackClick={onBackClick}
            readOnly={readOnly}
          />
        )}
        {currentStep === 3 && (
          <AllocationMatrixReview
            onStepChange={onStepChange}
            onBackClick={onBackClick}
            readOnly={readOnly}
          />
        )}
      </HStack>
    </Box>
  );
}
